module.exports = __webpack_public_path__ + "static/media/2020.7.10法律进社区 法制宣传活动.e225d06a.jpg";